import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { INotification } from '.';

const notificationsAdapter = createEntityAdapter<INotification>({
    selectId: (item) => item.id
});

export const notificationsSlice = createSlice({
    name        : 'notifications',
    initialState: notificationsAdapter.getInitialState(),
    reducers    : {
        setAll   : notificationsAdapter.setAll,
        remove   : notificationsAdapter.removeOne,
        removeAll: notificationsAdapter.removeAll
    }
});

export const { actions, reducer } = notificationsSlice;
export const { setAll, remove, removeAll } = actions;

export default notificationsSlice.reducer;
